import { render, staticRenderFns } from "./Epitasis.vue?vue&type=template&id=091963a6"
import script from "./Epitasis.vue?vue&type=script&lang=js"
export * from "./Epitasis.vue?vue&type=script&lang=js"
import style0 from "./Epitasis.vue?vue&type=style&index=0&id=091963a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports